import {
  FETCH_POWER_FACTOR_TREND_FAILURE,
  FETCH_POWER_FACTOR_TREND_REQUEST,
  FETCH_POWER_FACTOR_TREND_SUCCESS,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
  siteId: null,
  dateRange: null,
  receivedAt: null,
};

const serializePayload = (payload) => {
  try {
    return JSON.stringify(payload);
  } catch (error) {
    return undefined;
  }
};

const arePayloadsEqual = (currentPayload, nextPayload) => {
  if (currentPayload === nextPayload) return true;

  const currentSerialized = serializePayload(currentPayload);
  const nextSerialized = serializePayload(nextPayload);

  return currentSerialized !== undefined && currentSerialized === nextSerialized;
};

const powerFactorTrendReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_POWER_FACTOR_TREND_REQUEST: {
      const siteId = action.payload?.siteId;
      const dateRange = action.payload?.dateRange;
      const isSameScope = state.siteId === siteId && state.dateRange === dateRange;
      const hasCurrentData = state.data !== null && state.data !== undefined;

      return {
        ...state,
        loading: !(isSameScope && hasCurrentData),
        error: null,
        siteId,
        dateRange,
      };
    }
    case FETCH_POWER_FACTOR_TREND_SUCCESS: {
      const nextData = action.payload?.data;
      const dataChanged = !arePayloadsEqual(state.data, nextData);

      return {
        ...state,
        loading: false,
        data: dataChanged ? nextData : state.data,
        error: null,
        siteId: action.payload?.siteId,
        dateRange: action.payload?.dateRange,
        receivedAt: action.payload?.receivedAt,
      };
    }
    case FETCH_POWER_FACTOR_TREND_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload?.error || action.payload,
        siteId: action.payload?.siteId,
        dateRange: action.payload?.dateRange,
      };
    default:
      return state;
  }
};

export default powerFactorTrendReducer;
